import { OhsFilterList } from 'dashboard/topFilter/OhsFilterModels';
import { ApiResListsType } from 'global-services/api/OhsApiModels';
import { GlobalSearchState } from 'search/OhsSearchModels';
import { ModuleType } from 'global-services/constants/OhsObject';

import OhsQrCodeRecord from './OhsQrCodeRecord';

export enum OhsQrCodeViewPresets {
  View1QrCodeList = 'view1QrCodeList',
  View2QrCodeList = 'view2QrCodeList',
}

export const QrCodeAllowedModuleTypes = [ModuleType.Action, ModuleType.Incident];

export const QrCodeAllowedEventTypes = ['create'];

export interface QrCodeListsRecordState {
  isLoading: boolean;
  qrCodeLists: ApiResListsType<OhsQrCodeRecord[] | null>;
  allocatedList: any[] | null;
  currentPage: number;
  currentViewPreset: OhsQrCodeViewPresets;
}

export interface OhsQrCodeRootState {
  globalfilter: {
    filterInfo: OhsFilterList;
  };
  qrCode: QrCodeListsRecordState;
  globalSearch: GlobalSearchState;
}

export interface OhsQrCodeCustomFilters {
  workplaceOwned?: boolean;
  allocatedToOrg?: boolean;
  allocatedToWorkplace?: boolean;
  notAllocated?: boolean;
  archived?: boolean;
  workplaces?: string[];
  locations?: string[];
  locations_EMPTY?: boolean;
  next?: string;
}

export interface OhsQrCodeListsFilterPayload extends OhsQrCodeCustomFilters {
  viewPreset?: 'view_1' | 'view_2';
  page?: number;
  sort: {
    order: number;
    key: string;
  };
  count: boolean;
}

export interface AllocatedListType extends OhsQrCodeRecord {
  _id: string;
  type: ModuleType;
  allocated: boolean;
}

export interface QrCodeAllocListRes {
  items: AllocatedListType[];
}

export const eventSuccesfulMessageMap: Record<string, string> = {
  create: 'Created',
  signoff: 'Signed-Off',
};
